import React from 'react'
import { EditableTitle } from '../Common/EditableTitle'
import type { LineItem } from '../../types/ffe'

interface Props {
  item: LineItem
  onUpdate: (updates: Partial<LineItem>) => void
}

export const LineItemTitle: React.FC<Props> = ({ item, onUpdate }) => {
  return (
    <div className="item-title">
      <EditableTitle
        smallIcon
        value={item.name}
        onChange={(value) => onUpdate({ name: value })}
        placeholder="Add product title"
      />
    </div>
  )
}
